import { useEffect, useRef } from 'react';
import type { VideoJob } from '../services/local-video';
import './submitted-video.css';

export function SubmittedVideo({ job, error }: { job?: VideoJob | undefined; error: string }) {
  const notice = useRef<HTMLElement>(null);
  const jobId = job?.id;
  useEffect(() => { if (jobId) notice.current?.focus(); }, [jobId]);
  const heading = !job ? 'Checking your submitted video…' : job.state === 'completed' ? 'Your video is ready'
    : ['failed', 'submission_failed', 'revoked', 'cancelled'].includes(job.state) ? 'Your video needs attention' : 'Video submitted';
  return <section className="submitted-video" role="status" aria-live="polite" aria-busy={!job && !error} tabIndex={-1} ref={notice}>
    <h2>{heading}</h2>
    {job ? <><strong>{job.title}</strong><p>Follow its progress below. You can leave this page and return to My videos.</p></>
      : <p>{error ? 'Your submission was accepted, but its status could not be loaded. This page will keep checking.'
        : 'Your submission was accepted. Loading its status; you do not need to submit it again.'}</p>}
    <a href="/studio">Return to Studio</a>
  </section>;
}
